import * as Event from './../../_function/event.js';
import * as ModuleClass from './../../_function/class.js';
import * as Element from './../../_function/element.js';

// =============================================================================
// debug_console.js

var debug_console                 = document.getElementById( "debug_console" );
var debug_console__input_open     = document.getElementById( 'debug_console__input_open' );
var debug_console__input_shrink   = document.getElementById( 'debug_console__input_shrink' );
var debug_console__window_width   = document.getElementById( 'debug_console__window_width' );
var debug_console__window_height  = document.getElementById( 'debug_console__window_height' );
var debug_console__screen_width   = document.getElementById( 'debug_console__screen_width' );
var debug_console__screen_height  = document.getElementById( 'debug_console__screen_height' );
var debug_console__pixel_ratio    = document.getElementById( 'debug_console__pixel_ratio' );
var debug_console__input_shrink   = document.getElementById( 'debug_console__input_shrink' );
var debug_console__input_open     = document.getElementById( 'debug_console__input_open' );
var debug_console__url            = document.getElementById( 'debug_console__url' );
var debug_console__log            = document.getElementById( 'debug_console__log' );

var debugConsoleLog = 1;

var lastDebugMessage, lastDebugFile, lastDebugLoc;
var debugLogLast = [ '','','' ];

var levelText = [ [ '', 'Info: ', 'Warning: ', 'Error: ' ], [ '', 'debug-info', 'debug-warn', 'debug-error' ] ];

function isDebugConsoleEntryNew( idx, newer ) {
  if( idx > 0 && debugConsoleLog <= 0 ) return false;
  var debugConsoleEntryIsNew = newer !== debugLogLast[ idx ];
  if( debugConsoleEntryIsNew ) debugLogLast[ idx ] = newer;
  return debugConsoleEntryIsNew;
}

function debug_console_process( level, message, stack, forced ) {
  if( forced !== undefined || !forced ) {
    if( debugConsoleLog == -1 ) return;
    else if( debugConsoleLog == 0 ) {
      level = 1;
      message = "<i>debugConsoleLog</i> set to <b>false</b>";
      debugConsoleLog = -1;
    }
  }

	var debugMessage = "<span class='debug_console__log__entry__details__level'>" + levelText[ 0 ][ level ] + "</span>" + message;
	var debugData = new Array(), debugRegex = /((?:(?:https?|file)\:\/\/[^\s\)]+)(?:\/))([^:]+).([^\D\s]+).([^\D\s]+)/ig;

  while( debugRegex.exec( stack ) ) debugData.push( [ RegExp.$0, RegExp.$1, RegExp.$2, RegExp.$3, RegExp.$4 ] );

  var debugPath = debugData[ 0 ][ 1 ], debugFile = debugData[ 0 ][ 2 ], debugLineNum = debugData[ 0 ][ 3 ], debugColNum = debugData[ 0 ][ 4 ], debugLoc = debugLineNum + ":" + debugColNum;

  if ( isDebugConsoleEntryNew( 0, debugMessage ) ) {
    var newFile = isDebugConsoleEntryNew( 1, debugFile );
    var entryClasses = new Array();

    if ( !newFile ) entryClasses.push( 'debugconsole-samefile' );
    if ( levelText[ 1 ][ level ] != '' ) entryClasses.push( levelText[ 1 ][ level ] );
    entryClasses.push( 'clearfix' );

    var debug_console__log__entry = Element.addElement( debug_console__log, 'li', '', entryClasses );

    var debug_console__log__entry__details = Element.addElement( debug_console__log__entry, 'span',  '', 'debug_console__log__entry__details' );
    if ( newFile ) {
      var debugLink = Element.addElement( debug_console__log__entry__details, 'a',  '', [ 'debug_console__log__entry__details__location', 'debug_console__log__entry__details__location--file' ], debugFile );
      debugLink.href = debugPath + debugFile;
      Element.addElement( debug_console__log__entry__details, 'span',  '', [ 'debug_console__log__entry__details__location', 'debug_console__log__entry__details__location--file' ], ': ' );
    }
    if ( newFile || isDebugConsoleEntryNew( 2, debugLoc ) ) Element.addElement( debug_console__log__entry__details, 'span',  '', 'debug_console__log__entry__details__location', debugLoc );
    Element.addElement( debug_console__log__entry, 'div',  '', 'debug-icon' );
    Element.addElement( debug_console__log__entry, 'span',  '', 'debug-text', debugMessage );
  }
  else {
		var lastEntry = debug_console__log.lastElementChild, target = lastEntry.getElementsByClassName( 'debug_console__log__entry__details__count' )[ 0 ];

    if( target === undefined ) Element.addElementBefore( lastEntry.getElementsByClassName( 'debug_console__log__entry__details__location' )[ 0 ], 'span',  '', 'debug_console__log__entry__details__count', '2' );
		else {
			var content = parseInt( target.innerHTML );
			target.innerHTML = ( !isNaN( content ) && content !== undefined ? content : 1 ) + 1;
		}
	}

  return [ message ];
}

var debugConsole = Error;

debugConsole.prototype.write = function ( msg, forced ) {
  // var msg = Array.prototype.slice.call(arguments, 0);
	debug_console_process( 0, msg, this.stack, forced );
	console.log.apply( console, msg );
};

debugConsole.prototype.log   = function ( msg, forced ) { return console.log  .apply( console, debug_console_process( 0, msg, this.stack, forced ) ); };
debugConsole.prototype.info  = function ( msg, forced ) { return console.info .apply( console, debug_console_process( 1, msg, this.stack, forced ) ); };
debugConsole.prototype.warn  = function ( msg, forced ) { return console.warn .apply( console, debug_console_process( 2, msg, this.stack, forced ) ); };
debugConsole.prototype.error = function ( msg, forced ) { return console.error.apply( console, debug_console_process( 3, msg, this.stack, forced ) ); };

function debug_console_test() {
  debugConsole()  .log( "A basic log message"       );
  debugConsole() .info( "An information message"    );
  debugConsole() .warn( "A warning message"         );
  debugConsole().error( "An error message"          );

  debugConsole().log( " " );

  for (let i = 0; i <   3; i++) { debugConsole()  .log( "Duplicate basic log messages"   ); }
  for (let i = 0; i < 153; i++) { debugConsole() .info( "Duplicate information messages" ); }
  for (let i = 0; i <  28; i++) { debugConsole() .warn( "Duplicate warning messages"     ); }
  for (let i = 0; i <   4; i++) { debugConsole().error( "Duplicate error messages"       ); }

  debugConsole().log( " " );

  debugConsole().info( "A very long log message to demonstrate word wrapping in the Debug Console as well as demonstrating the behavior of the Debug Console Log title's sticky position. Just to be on the safe side, here is even more text to occupy space and ensure this adds enough height to the Debug Console Log." );
  debugConsole().info( "A second very long log message to demonstrate word wrapping in the Debug Console as well as demonstrating the behavior of the Debug Console Log title's sticky position. Just to be on the safe side, here is even more text to occupy space and ensure this adds enough height to the Debug Console Log." );
  debugConsole().info( "A third very long log message to demonstrate word wrapping in the Debug Console as well as demonstrating the behavior of the Debug Console Log title's sticky position. Just to be on the safe side, here is even more text to occupy space and ensure this adds enough height to the Debug Console Log." );
}

function amendButton( buttonSelect, buttonText, altTitle ) {
  buttonSelect.innerHTML = buttonText;
  buttonSelect.title = ( altTitle !== undefined ? altTitle : buttonText ) + ' Debug Console';
}

function debug_console_update_stat( element, text ) {
  if ( element.innerHTML != text ) element.innerHTML = text;
}

function debug_console_update_stats_screen() {
  debug_console_update_stat( debug_console__screen_width,  window.innerWidth );
  debug_console_update_stat( debug_console__screen_height, window.innerHeight );
  debug_console_update_stat( debug_console__pixel_ratio,   window.devicePixelRatio );
}

function debug_console_update_stats_viewport() {
  debug_console_update_stat( debug_console__window_width,  window.screen.width );
  debug_console_update_stat( debug_console__window_height, window.screen.height );
}

function debug_console_update_stats() {
  debug_console_update_stats_screen();
  debug_console_update_stats_viewport();
}

function debug_console_resize( init ) {
  if ( init ) debug_console_update_stats_screen();
  debug_console_update_stats_viewport();
}

function debug_console_init() {
  var debug_console__url__port_text   = window.location.port;
  var debug_console__url__search_text = window.location.search;
  var debug_console__url__hash_text   = window.location.hash;

  Element.addElement( debug_console__url, 'span',  '', 'debug_console__url__protocol', window.location.protocol );
  debug_console__url.innerHTML = debug_console__url.innerHTML + '//';
  Element.addElement( debug_console__url, 'span',  '', 'debug_console__url__hostname', window.location.hostname );
  if ( debug_console__url__port_text ) {
    debug_console__url.innerHTML = debug_console__url.innerHTML + ':';
    Element.addElement( debug_console__url, 'span',  '', 'debug_console__url__port', debug_console__url__port_text );
  }
  Element.addElement( debug_console__url, 'span',  '', 'debug_console__url__pathname', window.location.pathname );
  if ( debug_console__url__search_text ) Element.addElement( debug_console__url, 'span',  '', 'debug_console__url__search', debug_console__url__search_text );
  if ( debug_console__url__hash_text ) Element.addElement( debug_console__url, 'span',  '', 'debug_console__url__hash', debug_console__url__hash_text );
}

debug_console_init();
debug_console_resize( true );
debug_console_test();

Event.addEvent( 'resize', window, debug_console_resize );

var windowMoveInterval;

function windowMouseMoveUpdate( event ) {
  if ( event !== undefined && event.relatedTarget !== null ) {
    clearInterval( windowMoveInterval );
  }
  else {
    windowMoveInterval = setInterval( function () {
      debug_console_resize();
    }, 1000 );
  }
}

windowMouseMoveUpdate();

Event.addEvent( 'mouseout', window, windowMouseMoveUpdate );

function queueRefreshFrame() {
  setTimeout( function() {
    document.dispatchEvent( new CustomEvent( "refreshFrame" ) );
  }, 500 ); // 500ms is resize mixin duration
}

debug_console__input_open.addEventListener('click', function ( event ) {
  event.preventDefault();

  ModuleClass.toggleClass( debug_console, 'opened' );

  if( ModuleClass.hasClass( debug_console, 'opened' ) ) {
    amendButton( debug_console__input_open, 'X', 'Close' );
  }
  else {
    amendButton( debug_console__input_open, 'Open' );
  }

  queueRefreshFrame();

  return false;
} );

debug_console__input_shrink.addEventListener('click', function ( event ) {
  event.preventDefault();

  if( ModuleClass.hasClass( debug_console, 'opened' ) ) ModuleClass.toggleClass( debug_console, 'shrunk' );
  if( ModuleClass.hasClass( debug_console, 'shrunk' ) ) amendButton( debug_console__input_shrink, 'Expand' );
  else amendButton( debug_console__input_shrink, 'Shrink' );

  queueRefreshFrame();

  return false;
} );
